import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventLiveness } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import React from 'react';
import { useTranslation } from 'react-i18next';
import EventBodyEntry from '../event-body-entry';
type LivenessEventBodyProps = {
  data: UserTimelineEventLiveness['data'];
};
const LivenessEventBody = t0 => {
  const $ = _c(17);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.livenessEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    insightEvent,
    attributes
  } = data;
  const ipAddress = insightEvent?.ipAddress;
  let t2;
  if ($[1] !== attributes) {
    t2 = attributes ?? {};
    $[1] = attributes;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    issuers,
    device,
    os
  } = t2;
  let t3;
  if ($[3] !== issuers || $[4] !== t) {
    t3 = issuers && <EventBodyEntry content={<>{t(_temp)}{issuers?.map((issuer, i) => <React.Fragment key={issuer}><p className="text-label-2 mx-1">{capitalize(issuer)}</p>{i === issuers.length - 1 ? "" : " and "}</React.Fragment>)}</>} />;
    $[3] = issuers;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== device || $[7] !== os || $[8] !== t) {
    t4 = device && <EventBodyEntry content={<>{t(_temp2)}<p className="text-label-2 ml-1">{`${device} (${os ?? ""})`}</p></>} />;
    $[6] = device;
    $[7] = os;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== ipAddress || $[11] !== t) {
    t5 = ipAddress && <EventBodyEntry content={<>{t(_temp3)}<p className="text-label-2 ml-1">{ipAddress}</p></>} />;
    $[10] = ipAddress;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div data-test-id="liveness-event-body" data-dd-privacy="mask">{t3}{t4}{t5}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default LivenessEventBody;
function _temp($) {
  return $.attestedBy;
}
function _temp2($_0) {
  return $_0.deviceOs;
}
function _temp3($_1) {
  return $_1.ipAddress;
}